module.exports = __webpack_public_path__ + "img/orange1.10cc0b12.png";